import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { BulldogComponent } from './bulldog/bulldog.component';
import { FrontpageComponent } from './frontpage/frontpage.component';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppInsightsService } from '../services/AppInsightsService';

@NgModule({
  declarations: [
    AppComponent,
    AboutUsComponent,
    BulldogComponent,
    FrontpageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [AppInsightsService],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(appInsights: AppInsightsService) {
  }
}
